/**
 * LLMs occasionally emit GFM tables with row breaks collapsed onto one line,
 * e.g. "| A | B || C | D |". Insert newlines so remark-gfm can parse them.
 */
export function normalizeAgentMarkdown(text: string): string {
  if (!text.includes('|')) {
    return text;
  }

  const looksLikeTable =
    /\|[-:\s|]+\|/.test(text) || /\|[^|\n]+\|[^|\n]+\|/.test(text);
  if (!looksLikeTable) {
    return text;
  }

  let out = text.replace(/\|\|/g, '|\n|');
  // Header row immediately followed by a separator row, e.g. "| A | B | |---|"
  out = out.replace(/\|\s+\|(?=[-:])/g, '|\n|');
  out = out.replace(/(\|[^|\n]+(?:\|[^|\n]+)*\|)\s+(?=\|[^|\n])/g, '$1\n');
  return out;
}
